
import { defineComponent, toRaw } from "vue"

export default defineComponent({
  data: () => ({
    cards: toRaw([
      "Предоставление возможностей участникам Фестиваля для демонстрации и&nbsp;популяризации своих разработок и&nbsp;изобретений как на&nbsp;региональном, так и&nbsp;федеральном уровнях.",
      "Повышение интереса к&nbsp;теме изобретательства среди широкой аудитории.",
      "Повышение престижа карьеры ученого и изобретателя.",
      "Создание организационной цифровой платформы для дальнейшего привлечения внимания к&nbsp;разработкам российских ученых и&nbsp;изобретателей.",
    ] as const),
  }),
})
